// Единственное место, которое знает, в КАКОМ поле у какого типа блока лежит фон.
// Все типы, включая info, ПИШУТ тему в верхнеуровневое `bgColor` (BlockBase) —
// так же, как design и article. У info есть легаси-фолбэк на чтение: у уже
// созданных курсов тема лежала во вложенном `body.bgColor` (так писал старый
// InfoBlockEditor), и это значение никуда не делось — PUT частичный, `null`
// его не обнуляет (docs/backend/gamified-course-update-fields.md), а гонять
// туда пустую строку ради косметики не стоит. Приоритет: `bgColor` важнее,
// `body.bgColor` — только если верхнеуровневого поля нет вовсе, иначе у всех
// старых info-блоков фон молча пропал бы.
import {
  patternLayer,
  resolveLessonBackground,
  resolveLessonThemeId,
  resolvePatternId,
} from '@teach/ui'
import type { BlockCreate } from '@/types/blocks'

// Тип параметра — BlockCreate (без BlockMeta), а не Block: превью получают блок
// в его собственном узком типе (DesignBlock/InfoBlock/ArticleBlock), не полный
// Block с id/createdAt/updatedAt — тех полей резолверу и не нужно.
export const blockBackground = (block: BlockCreate): string => {
  const bgColor = block.bgColor ?? (block.type === 'info' ? block.body?.bgColor : null)
  const background = resolveLessonBackground(bgColor)
  // Тема нужна только чтобы выбрать цвет узора. Легаси-цвет темой не является —
  // берём цвета темы 1: паттерн автор выбрал явно, и прятать его нельзя.
  const themeId = resolveLessonThemeId(bgColor) ?? 'theme1'
  const layer = patternLayer(themeId, resolvePatternId(block.patternType))
  return layer ? `${layer}, ${background}` : background
}
